import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarVerracos/descargarExcelVerracos`, method: 'GET', body: null, token: token})
}
